import { comingSoon } from '../content/wedding';
import { Reveal } from './Reveal';
import { Rule } from './Rule';

/**
 * Stands in for a section whose particulars are not settled yet.
 *
 * Drawn in the same plate language as everything around it — hairline keyline,
 * brass lozenge, one line of copy — so a section that is waiting still reads as
 * part of the invitation rather than as a hole in it. Every colour is inherited
 * rather than named, so the one component serves the forest band and the paper
 * sections without a variant.
 *
 * Which sections show this is decided by `comingSoon` in `content/wedding.ts`.
 */
export function Soon({ children }: { children: string }) {
  return (
    <Reveal class="soon">
      <span class="eyebrow">{comingSoon.eyebrow}</span>
      <Rule class="soon__rule" short />
      <p class="soon__note">{children}</p>
    </Reveal>
  );
}
